<template>
    <section class="section-hero section-shaped my-0">
        <div class="shape shape-style-1 shape-primary">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <img src="img/brand/white.png" style="width: 200px;" class="img-fluid">
                        
                        <div class="row justify-content-between align-items-center">
                            <h1 class="text-white font-weight-light">Hi，这里是一个关于健康饮食的个人网站。</h1>
                            <p class="lead text-white mt-4">目前小范围内测中，还未对外开放，
                                    更多信息可以在个人微博主页了解。微博 ID：AnthroMindXX。</p>
                        </div>

                        <div class="btn-wrapper">
                          
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>
<script>
export default {};
</script>
<style>
</style>
